import {
  DocumentFile,
  DocumentMetadata,
  DocumentTypeToCreate,
} from "../models/Document";
import axiosInstance from "./axiosInstance";

const uploadDocuments = async (
  files: DocumentFile[],
  documentsMetadataArray: DocumentMetadata[]
) => {
  const formData = new FormData();

  files.forEach((file: DocumentFile) => {
    if (file.files instanceof Blob) {
      formData.append("files", file.files, file.files.name);
    } else {
      console.error("File is not valid");
    }
  });

  formData.append("documentsData", JSON.stringify(documentsMetadataArray));

  const response = await axiosInstance.post(
    "/customer/documents/save",
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    }
  );

  return response.data;
};

const getKycCustomer = async () => {
  const response = await axiosInstance.get("/document/type/customer");
  return response.data;
};
const getKycEnterprise = async () => {
  const response = await axiosInstance.get("/document/type/enterprise");
  return response.data;
};

const createDocumentType = async (document: Partial<DocumentTypeToCreate>) => {
  const response = await axiosInstance.post("document/type/create", document);
  return response.data;
};

const getAllTypes = async () => {
  const response = await axiosInstance.get("/document/type/all");
  return response.data;
};

const updateDocument = async (
  documentId: string,
  updatedData: Partial<DocumentTypeToCreate>
) => {
  const response = await axiosInstance.post(
    `/document/type/update/${documentId}`,
    updatedData
  );
  return response.data;
};
const validateDocument = async (customerId: string, documentId: string) => {
  const response = await axiosInstance.patch(
    `document/validate/${customerId}/${documentId}`
  );
  return response.data;
};

const rejectDocument = async (
  customerId: string,
  documentId: string,
  reason: string
) => {
  const response = await axiosInstance.patch(
    `document/rejet/${customerId}/${documentId}`,
    { reason }
  );
  return response.data;
};

const getAllCountries = async () => {
  const response = await axiosInstance.get("countries/all");
  return response.data;
};

export const DocumentService = {
  uploadDocuments,
  createDocumentType,
  getAllTypes,
  updateDocument,
  validateDocument,
  rejectDocument,
  getAllCountries,
  getKycCustomer,
  getKycEnterprise
};
